import { render, staticRenderFns } from "./Technology.vue?vue&type=template&id=78704cfb&scoped=true&"
import script from "./Technology.vue?vue&type=script&lang=js&"
export * from "./Technology.vue?vue&type=script&lang=js&"
import style0 from "./Technology.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Technology.vue?vue&type=style&index=1&id=78704cfb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78704cfb",
  null
  
)

export default component.exports